module.exports = __webpack_public_path__ + "img/phone_call.8394b602.svg";